module.exports = __webpack_public_path__ + "img/NorthDash_TitleCupidon.5851fa33.png";